export var SwitchTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState;
            return ({
                width: 52,
                height: 34,
                '.MuiSwitch-thumb': {
                    backgroundColor: ownerState.checked === true
                        ? theme.palette[ownerState.color ? ownerState.color : 'success']
                            .main
                        : theme.palette.greySecondary[300],
                },
                '.Mui-checked': {
                    '.MuiSwitch-thumb': {
                        backgroundColor: theme.palette[ownerState.color ? ownerState.color : 'success'].main,
                    },
                    '&.Mui-disabled': {
                        '.MuiSwitch-thumb': {
                            boxShadow: "none",
                            backgroundColor: theme.palette.greySecondary[200],
                        },
                        '+ .MuiSwitch-track': {
                            backgroundColor: theme.palette.greySecondary[50],
                        },
                    },
                },
                '.Mui-disabled': {
                    '.MuiSwitch-thumb': {
                        boxShadow: "none",
                        backgroundColor: theme.palette.greySecondary[200],
                    },
                    '+ .MuiSwitch-track': {
                        opacity: "1 !important",
                        backgroundColor: theme.palette.greySecondary[50],
                    },
                },
            });
        },
        switchBase: {
            left: 3,
            '&.Mui-checked': {
                transform: "translateX(12px)",
            },
        },
        thumb: {
            width: 16,
            height: 16,
        },
        track: {
            opacity: 1,
            backgroundColor: theme.palette.greySecondary[100],
        },
    },
}); };
export default SwitchTheme;
//# sourceMappingURL=theme.js.map